import TickerAnimation from "../TickerAnimation";
import SVGComponent from "../SVGComponent";
import useCategories from "../../../utils/useCategories";

/**

@param {OnClickEventHandler} props.handledata,  - category data are showing
@param {string} props.logoIcon - icon/SVG image path to display
@param {string} props.category_url - Category path URL display on card
@param {OnClickEventHandler} props.SelectedbackgroundColour - category selection function
@param {Object} props.handleCategorySelect - All category are showing to card
@param {string} [props.categoryNameColour] - categoryName Font colour 
@param {string} [props.categoryTextSize] - categoryName Font Size 
@param {string} [props.categoryFontWeight] - categoryName Font weight 
  
*/

const CategoriesCard = ({
  handledata,
  logoIcon,
  selectedBackgroundColour,
  handleCategorySelect,
  flow,
}) => {
  const categoryMapper = useCategories();
  const categoryIcon = categoryMapper(handledata?.id);

  return (
    <div
      onClick={() => {
        handleCategorySelect(handledata?.id);
      }}
      className={`bg-primary-nav rounded-border-radius-md mr-margin-md flex ${
        flow === "switch_account" ? "cursor-not-allowed" : "cursor-pointer"
      }`}
    >
      <div className="p-padding-sm border-r flex items-center bg-text-primary rounded-l-border-radius-md">
        <div className="w-icon-lg h-icon-lg flex-shrink-0">
          <SVGComponent
            url={categoryIcon?.url}
            color={categoryIcon?.colour}
            height="var(--icon-lg)"
            width="var(--icon-lg)"
            alt={handledata?.name}
          />
        </div>
      </div>

      <div
        className={`flex w-full group relative bg-primary-nav ${
          flow === "switch_account" ? "" : "global-hover-white"
        } rounded-r-border-radius-md z-z-index-base transition-colors duration-animation-fast-s overflow-auto`}
      >
        <div
          className={`absolute bg-positive-bg z-z-index-header ${flow === "switch_account" ? "" : "group-hover:bg-positive-bg-hover"}`}
          style={{
            transform:
              selectedBackgroundColour === "primary-nav"
                ? "scale(0)"
                : "scale(1)",
            transformOrigin: "right",
            transition:
              selectedBackgroundColour === "primary-nav"
                ? "transform var(--animation-fast-xs) ease-in"
                : "transform var(--animation-fast-s) ease-in",
            height: "var(--height-full)",
            width: "calc(var(--width-full) - var(--icon-lg))",
          }}
        />

        <div
          className={`absolute bg-positive-bg z-z-index-header ${flow === "switch_account" ? "" : "group-hover:bg-positive-bg-hover"}`}
          style={{
            transform:
              selectedBackgroundColour === "primary-nav"
                ? "scale(0)"
                : "scale(1)",
            transformOrigin: "left",
            transition:
              selectedBackgroundColour === "primary-nav"
                ? "transform var(--animation-fast-xs) ease-in"
                : "transform var(--animation-fast-s) ease-in",
            left: "calc(var(--left-full) - var(--icon-lg))",
            height: "var(--height-full)",
            width: "var(--icon-lg)",
            borderRadius:
              "var(--border-base) var(--border-radius-md) var(--border-radius-md) var(--border-base)",
          }}
        />
        <div className="w-full flex flex-col justify-center pl-padding-sm min-w-0 relative z-[unset] gap-gap-xs">
          <p className="text-text-primary relative z-z-index-header text-font-sm font-semibold">
            <TickerAnimation text={handledata?.name} />
          </p>
          {handledata?.description && (
            <p className="text-text-secondary text-font-xs relative z-z-index-header font-normal">
              <TickerAnimation text={handledata?.description} />
            </p>
          )}
        </div>
        <div
          className={`flex justify-end relative z-[unset] ${
            !logoIcon ? "pr-padding-md" : "p-padding-md"
          }`}
        >
          {logoIcon && (
            <div className="w-icon-md relative z-z-index-header">
              <img
                src={logoIcon}
                alt={selectedBackgroundColour ? "selected" : "not selected"}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CategoriesCard;
